import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
export const generatePDF = async (certificateRef, fileName) => {
    console.log('Generating PDF...');
    if (!certificateRef.current) {
        return;
    }
    try {
        // Get the element's dimensions
        const element = certificateRef.current;
        // Capture the component as canvas using html2canvas
        const canvas = await html2canvas(element, {
            scale: 2, // Higher scale for better quality
            useCORS: true,
            logging: false,
            backgroundColor: 'white',
            width: element.offsetWidth,
            height: element.offsetHeight,
        });
        // Convert canvas dimensions to mm (assuming 96 DPI)
        const pixelsPerMm = 3.779527559; // 96 DPI / 25.4 mm per inch
        const imgWidth = canvas.width / pixelsPerMm;
        const imgHeight = canvas.height / pixelsPerMm;
        // Create PDF with dimensions matching the element
        // eslint-disable-next-line new-cap
        const pdf = new jsPDF({
            orientation: imgWidth > imgHeight ? 'landscape' : 'portrait',
            unit: 'mm',
            format: [imgWidth, imgHeight],
        });
        // Add the captured canvas to PDF
        const imgData = canvas.toDataURL('image/png');
        pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
        pdf.setDisplayMode('fullpage', 'continuous', 'FullScreen');
        // Save the PDF
        pdf.save(`${fileName}.pdf`);
    }
    catch (error) {
        console.error('Error generating certificate of completion PDF:', error);
    }
};
